import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import './index.scss'

function PortfolioItem(props) {
  const [currentIndex, setCurrentIndex] = useState(0)
  const images = Array.isArray(props.src) ? props.src : [props.src]
  const hasMultipleImages = images.length > 1
  const objectFitStyle = props.objectFit || 'cover'

  const nextSlide = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length)
  }

  const prevSlide = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length)
  }

  return (
    <li className="cards__item">
      <Link className="cards__item__link" to={props.link}>
        <p className="label_text">{props.label}</p>
        <figure className="cards__item__pic-wrap" data-category={props.label}>
          <img
            src={images[currentIndex]}
            alt="Portfolio"
            className="cards__item__img"
            style={{ objectFit: objectFitStyle }}
          />
          {hasMultipleImages && (
            <div className="slider-controls">
              <button className="slider-btn prev" onClick={prevSlide} type="button">
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <button className="slider-btn next" onClick={nextSlide} type="button">
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          )}
          <figcaption>{props.label}</figcaption>
        </figure>
        <div className="cards__item__info">
          <h5 className="cards__item__text">{props.text}</h5>
        </div>
      </Link>
    </li>
  )
}

export default PortfolioItem
